"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @ts-nocheck

var v4_1 = __importDefault(require("uuid/v4"));

function initialState() {
  return {
    class: "contract",
    type: null,
    subType: null,
    party: null,
    asset: null,
    additionalDescription: null,
    codebtors: [],
    // NOTE: Some other fields that may be useful?
    // contractType: null, // 'property', 'vehicle', 'other', 'timeshare'
    // contractIntent: null, // 'none', 'assume', 'reject'
    assumed: false // Instead of types? ^ There is no reject
    // contractNumber: null,
    // natureOfInterest: null, // 'purchaser', 'agent', 'lessor', 'lessee'
    // termRemaing: null, // Something?
    // party: null, // 'creditor'
    // value: 0,
    // valueMonthly: 0,
    // arrearage: 0,
    // interest: null, // 'debtor_1', 'debtor_2', 'both', 'one_and_another'
    // community: null,

  };
}

var createContract = function createContract(attrs) {
  return _objectSpread(_objectSpread(_objectSpread({}, initialState()), attrs), {}, {
    id: (0, v4_1.default)()
  });
};

exports.default = createContract;